<template>
  <div>
    <b-modal
      ref="modal"
      title="Configurações de Vendas"
      header-class="border-bottom-0"
      footer-class="border-top-0"
      size="lg"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-md-12">
            <h5 class="text-primary">
              <i class="fas fa-cubes" /> Estoque
            </h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <b-form-checkbox
                switch
                v-model="form.module_stock_active.value"
                :value="1"
                :unchecked-value="0"
              >Habilitar Controle de Estoque?</b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row" v-if="form.module_stock_active.value == 1">
          <div class="col-md-12">
            <div class="form-group">
              <b-form-checkbox
                switch
                v-model="form.order_emit_stock_transaction_on_store_order.value"
                :value="1"
                :unchecked-value="0"
              >Lançar Estoque ao Finalizar a venda?</b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-md-12 mb-2">
            <h5 class="text-primary">
              <i class="fas fa-dollar-sign" /> Plano de Contas Padrão
            </h5>
          </div>
        </div>
          <div class="row">
            <div class="col-md-6 mb-2">
            <account-plan-search
              @accountPlanSelected="setAccountPLan($event)"
            />
            </div>
          </div>

        <div class="row mt-5">
          <div class="col-md-12 mb-2">
            <h5 class="text-primary">
              <i class="fas fa-dollar-sign" /> Políticas de Preços e Descontos
            </h5>
          </div>
        </div>
        <div class="row">

            <div class="form-group">
              <b-form-group >
                  <div class="col-12">
                <b-form-radio-group
                     v-model="form.product_payment_policy.value"
                     :options="form.product_payment_policy.options"
                ></b-form-radio-group>
                  </div>
              </b-form-group>

             <template v-if="form.product_payment_policy.value == 2">
              <div class="form-group">
                <b-card>
              <b-form-checkbox
                switch
                v-model="form.order_apply_price_payment_on_terms_payment_method_2.value"
                :value="1"
                :unchecked-value="0"
              >Aplicar preço á prazo ao receber vendas com cheque?
              </b-form-checkbox>
               <b-form-checkbox
                switch
                v-model="form.order_apply_price_payment_on_terms_payment_method_3.value"
                :value="1"
                :unchecked-value="0"
              >Aplicar preço á prazo ao receber vendas com cartões de crédito?
              </b-form-checkbox>
               <b-form-checkbox
                switch
                v-model="form.order_apply_price_payment_on_terms_payment_method_4.value"
                :value="1"
                :unchecked-value="0"
              >Aplicar preço á prazo ao receber vendas com cartões de débito?
              </b-form-checkbox>
               <b-form-checkbox
                switch
                v-model="form.order_apply_price_payment_on_terms_payment_method_5.value"
                :value="1"
                :unchecked-value="0"
              >Aplicar preço á prazo ao receber vendas no crediário?
              </b-form-checkbox>
               <b-form-checkbox
                switch
                v-model="form.order_apply_price_payment_on_terms_payment_method_15.value"
                :value="1"
                :unchecked-value="0"
              >Aplicar preço á prazo ao receber vendas com boleto?
              </b-form-checkbox>
              </b-card>
            </div>
             </template>

            </div>



        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <b-form-checkbox
                switch
                v-model="form.order_disable_change_table_price.value"
                :value="1"
                :unchecked-value="0"
              >Não permitir alteração do preço do produto ao realizar vendas?</b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <b-form-checkbox
                switch
                v-model="form.order_enable_max_discount.value"
                :value="1"
                :unchecked-value="0"
              >Definir desconto máximo por forma de pagamento?</b-form-checkbox>
            </div>
          </div>
        </div>
        <template  v-if="form.order_enable_max_discount.value == 1">
          <div class="row mt-0">
            <div class="col-md-4">
              <number-input
                :alias="'Desconto Máximo Dinheiro'"
                v-model="form.order_max_discount_payment_method_1.value"
                :currencySymbol="' %'"
              />
            </div>
            <div class="col-md-4">
              <number-input
                :alias="'Desconto Máximo Débito'"
                v-model="form.order_max_discount_payment_method_2.value"
                :currencySymbol="' %'"
              />
            </div>
            <div class="col-md-4">
              <number-input
                :alias="'Desconto Máximo Crédito'"
                v-model="form.order_max_discount_payment_method_3.value"
                :currencySymbol="' %'"
              />
            </div>
          </div>
          <div class="row mt-0">
            <div class="col-md-4">
              <number-input
                :alias="'Desconto Máximo Cheque'"
                v-model="form.order_max_discount_payment_method_4.value"
                :currencySymbol="' %'"
              />
            </div>
            <div class="col-md-4">
              <number-input
                :alias="'Desconto Máximo Credito Loja'"
                v-model="form.order_max_discount_payment_method_5.value"
                :currencySymbol="' %'"
              />
            </div>
            <div class="col-md-4">
              <number-input
                :alias="'Desconto Máximo Boleto'"
                v-model="form.order_max_discount_payment_method_15.value"
                :currencySymbol="' %'"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <small
                class="text-muted"
              >Caso a venda tenha duas formas de pagamento, prevalecerá o menor desconto.</small>
            </div>
          </div>
        </template>

        <h5 class="text-primary mt-5 mb-2" style="margin-bottom: 0px;">
          <i class="fas fa-file-invoice-dollar"></i> Crédito Loja
        </h5>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <b-form-checkbox
                switch
                v-model="form.order_block_clients_with_overdued_bill.value"
                :value="1"
                :unchecked-value="0"
              >Bloquear vendas por Crédito ou Boleto para clientes com contas em atraso.</b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row"  v-if="form.order_block_clients_with_overdued_bill.value == 1">
           <div class="col-md-12">
            <number-input
              :alias="'Bloquear com'"
              :decimalPlaces="0"
              v-model="form.order_block_clients_with_overdued_bill_after_days.value"
              :currencySymbol="' dias após vencimento'"
            />
          </div>
        </div>

        <h5 class="text-primary mt-5 mb-2" style="margin-bottom: 0px;">
          <i class="fas fa-user-tie"/> Comissão 
        </h5>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <number-input
                :alias="'Definir percentual de comissão para todos os produtos'"
                v-model="form.comission_rate.value"
                :currencySymbol="' %'"
              />
            </div>
          </div>
        </div>            
      </div>

      <error-handler :error="error"/>

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "./../../mixins/Form";
import accountPlanSearch from "../../components/account/search/accountPlanSearch";


export default {
  components: {
    accountPlanSearch
  },

  data: function() {
    return {
      form: new Form({
        id: {},

        module_stock_active: {},

        module_nfe_active: {},

        product_payment_policy:{
            options:[
                   { text: 'Ultilizar somente um preço para vendas á prazo e  á vista', value: 1 },
                   { text: 'Ultilizar preços diferentes para vendas á prazo e  á vista', value: 2 },
            ]
        },

        order_emit_stock_transaction_on_store_order: {},

        order_disable_change_table_price: {},

        order_disable_custom_payment_options: {},

        order_enable_max_discount: {},

        order_max_discount_payment_method_1 : {},

        order_max_discount_payment_method_2 : {},

        order_max_discount_payment_method_3 : {},

        order_max_discount_payment_method_4 : {},

        order_max_discount_payment_method_5 : {},

        order_max_discount_payment_method_15 : {},

        order_apply_price_payment_on_terms_payment_method_1 : {},

        order_apply_price_payment_on_terms_payment_method_2 : {},

        order_apply_price_payment_on_terms_payment_method_3 : {},

        order_apply_price_payment_on_terms_payment_method_4 : {},


        order_apply_price_payment_on_terms_payment_method_5 : {
            default: 1
        },

        order_apply_price_payment_on_terms_payment_method_15 : {
             default: 1
        },

        order_block_clients_with_overdued_bill : {},

        order_block_clients_with_overdued_bill_after_days : {},

        account_plan_default_for_order	: {},

        comission_rate: {}

      }),

      error : null
    };
  },

  computed: {
        pricePolicy() {
            return this.form.product_payment_policy.value
        },

        accountPlans(){
          console.log(this.$store.state.accountPlan.accountPlans.data)
            return this.$store.state.accountPlan.accountPlans.data
        }
    },

   watch: {
        pricePolicy(newValue) {
            this.form.product_payment_policy.value = newValue;
        }
    },


  methods: {
    open() {
      this.error = null

      this.form.setValues(this.$store.state.company);

      this.$refs.modal.show();
    },

     setAccountPLan(accountplan) {
      this.form.account_plan_default_for_order.value = accountplan.id;
    },

    store() {
      this.$store.commit("showLoading");
      axios
        .post("api/company/updateordersettings", this.form.getValues())
        .then(response => {
          this.$store.commit("updateCompany", { company: response.data });

          this.$refs.modal.hide();

          this.$store.commit("hideLoading");
        })
        .catch(error => {
          this.error = error;

          this.$store.commit("hideLoading");
        });
    }
  }
};
</script>

<style>
</style>
